<script lang="ts" setup>
import type { ComponentElementsLinkIcon } from '@autobid/strapi-integration/graphql/graphql'
import FilterCount from '@autobid/ui/componentsGlobal/sections/searchFormColumnsGroup/sticker/FilterCount.vue'

interface Props {
  data: ComponentElementsLinkIcon
}

defineProps<Props>()
</script>

<template>
  <layout-header-partials-link
    class="items-center"
    :link-attributes="{ href: data.url }"
  >
    {{ data.text }}

    <template v-if="data.icon" #icon>
      <CommonIcon :name="data.icon" class="h-9 w-9" />
      <FilterCount v-if="data.role === 'search'" class="lg:hidden" />
    </template>
  </layout-header-partials-link>
</template>
